import React, { useEffect } from "react";
import PageTitleCard from "../../../templates/PageTitleCard";
import PageHeading from "../../../../templates/PageHeading";
import { BASEURL } from "../../../../../utils/BaseUrl";
import axios from "axios";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import BorderLine from "../../../../templates/borderline/BorderLine";
import FixedFooter from "../../../templates/FixedFooter";
import BackHome from "../../../../templates/BackHome";
import Underline from "../../../../../admin/pages/dashboard/Underline";
import RightArrow from "../../../../templates/RightArrow";
import CurrentPath from "../../../../templates/CurrentPath";
import SubHeadingText from "../../../../common/SubHeadingText";
import { useOtpSTatus } from "../../../../../context/OtpContext";

const BrochureList = () => {
  const { data } = useQuery({
    queryKey: "getAllBrochre",
    queryFn: () =>
      axios.get(`${BASEURL}brochure`).then((res) => {
        return res?.data;
      }),
  });

  const navigate = useNavigate();
  const { otpStatus, setOtpStatus } = useOtpSTatus();
  useEffect(() => {
    setOtpStatus(false);
  }, []);

  return (
    <div>
      <PageTitleCard>
        <PageHeading>Brochure</PageHeading>
        <div className="flex justify-evenly items-center">
          <BackHome /> <RightArrow /> <CurrentPath>Brochure</CurrentPath>
        </div>
      </PageTitleCard>
      <FixedFooter>
        <div className="container mx-auto py-8 max-sm:px-8">
          <SubHeadingText>Our Brochure</SubHeadingText>

          <div className="grid lg:grid-cols-4 md:grid-cols-2 sm:grid-cols-1 max-sm:grid-cols-1 gap-10  max-sm:place-items-center py-8">
            {data?.brochures?.map((v, i) => {
              return (
                <div key={i}>
                  <div class="relative duration-300  hover:-rotate-0  -rotate-6 group border-2    overflow-hidden rounded-2xl  h-32 w-72 bg-gray-200 p-5 flex flex-col items-start gap-4">
                    <div class="text-gray-50">
                      <p class="text-lg capitalize text-black font-semibold">
                        {v?.title}
                      </p>
                    </div>
                    <button
                      onClick={() =>
                        navigate(`/emailverify`, { state: { id: v?.id } })
                      }
                      class="duration-300 hover:bg-sport-yellow border hover:text-gray-50 bg-gray-50 font-semibold text-sport-yellow px-3 py-2 flex flex-row items-center gap-3"
                    >
                      Dowload Brochure
                      <svg
                        class="w-6 h-6 fill-current"
                        height="100"
                        preserveAspectRatio="xMidYMid meet"
                        viewBox="0 0 100 100"
                        width="100"
                        x="0"
                        xmlns="http://www.w3.org/2000/svg"
                        y="0"
                      >
                        <path
                          d="M22.1,77.9a4,4,0,0,1,4-4H73.9a4,4,0,0,1,0,8H26.1A4,4,0,0,1,22.1,77.9ZM35.2,47.2a4,4,0,0,1,5.7,0L46,52.3V22.1a4,4,0,1,1,8,0V52.3l5.1-5.1a4,4,0,0,1,5.7,0,4,4,0,0,1,0,5.6l-12,12a3.9,3.9,0,0,1-5.6,0l-12-12A4,4,0,0,1,35.2,47.2Z"
                          fill-rule="evenodd"
                        ></path>
                      </svg>
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </FixedFooter>
    </div>
  );
};

export default BrochureList;
